module.exports = __webpack_public_path__ + "img/img12.8aa4278e.png";